import { Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PwaService {
  private promptEvent: any;

  constructor(private swUpdate: SwUpdate) {
    // this.checkForUpdates();
    this.handleInstallPrompt();
  }

  // checkForUpdates() {
  //   if (this.swUpdate.isEnabled) {
  //     this.swUpdate.versionUpdates
  //       .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
  //       .subscribe(() => {
  //         this.showUpdateAvailable();
  //       });
  //   }
  // }

  // showUpdateAvailable() {
  //   const result = confirm('Update tersedia! Klik OK untuk memperbarui aplikasi.');
  //   if (result) {
  //     window.location.reload();
  //   }
  // }

  handleInstallPrompt() {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      this.promptEvent = e;
      this.showInstallButton();
    });
  }

  showInstallButton() {
    // Tampilkan tombol install di UI Anda
    console.log('PWA dapat diinstall');
  }

  installPwa() {
    if (this.promptEvent) {
      this.promptEvent.prompt();
      this.promptEvent.userChoice.then((result: any) => {
        if (result.outcome === 'accepted') {
          console.log('PWA berhasil diinstall');
        }
        this.promptEvent = null;
      });
    }
  }
}
